import { type FC } from 'react';

import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';
import { useIntersectionObserver } from '@/packages/react-utils/useIntersectionObserver';

import { SEOBottomLinksBlock } from '../SEOBottomLinksBlock';

import { trackCrosslinksClick, trackCrosslinksShown } from './internal/tracking';

export const CrosslinksContainer: FC = () => {
  const { data } = useSearchOffersDesktopQuery();

  const crosslinks = data?.pages[0].seo.view;

  const { elementRef } = useIntersectionObserver<HTMLDivElement>(
    {
      observerOptions: { threshold: 0.5 },
      onInViewport({ subscribeState, observer }) {
        trackCrosslinksShown();

        observer.disconnect();
        subscribeState.setSubscribeUnavailable();
      },
    },
    [crosslinks],
  );

  if (!crosslinks) {
    return null;
  }

  return (
    <SEOBottomLinksBlock
      links={crosslinks.links}
      ref={elementRef}
      title={crosslinks.title}
      trackLinkClick={trackCrosslinksClick}
    />
  );
};
